

export const capitalizeWord = (str) => {
    const newWord = str.charAt(0).toUpperCase() + str.slice(1);
    return newWord;
}